'use strict';

module.exports = function (h, that) {

  return function (row, column, refToEdit, position, type) {

    var data = {
      'row': row,
      'column': column,
      'refToEdit': refToEdit,
      'position': position
    };
    if (type === 'date') {
      return h('span', [' datepicker needed!!']);
    } else {
      return h('span', [h('input', {

        'class': 'form-control',
        attrs: { name: 'vef__' + column,
          type: 'text',
          placeholder: that.display('setField', { column: that.getHeading(column) })
        },
        domProps: {
          'value': row[column]
        }
      }), h(
        'span',
        {
          'class': 'btn btn-success',
          on: {
            'click': that.setCellValue.bind(that, data)
          }
        },
        [' Ok ']
      ), h(
        'span',
        {
          'class': 'btn btn-danger',
          on: {
            'click': that.cancelCellEdit.bind(that, refToEdit)
          }
        },
        [' Cancel ']
      )]);
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/template/edit-cell-template.js